/**
 * Month-range validity (Phase 3, §6.3). The backend accepts only well-formed
 * `JJJJ-MM` months with `from <= to` (422 `invalid_month` / `range_invalid`
 * otherwise) — the Berichte UI must never fire a report query outside this.
 */
import type { MonthRange } from '../../lib/queryKeys.ts';

export const MONTH_RE = /^\d{4}-(0[1-9]|1[0-2])$/;

/** True when both months are well-formed `JJJJ-MM` and `from <= to`. */
export function isValidMonthRange(range: MonthRange): boolean {
  return MONTH_RE.test(range.from) && MONTH_RE.test(range.to) && range.from <= range.to;
}
